import { Pipe, PipeTransform } from '@angular/core';
import {Unit} from '../models/service-pricing';

@Pipe({ name: 'pricingUnit' })
export class PricingUnitPipe implements PipeTransform {
  transform(value: Unit | string): string {
    const map: Record<string, string> = {
      [Unit.Order]: 'Orden',
      [Unit.LoadUnit]: 'Carga',
      [Unit.Package]: 'Paquete',
      [Unit.Good]: 'Mercancía',
      [Unit.NotDefined]: 'No definido',
    };
    return map[value] || value.toString();
  }
}
